import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GraphIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "19",
    width: "18",
    height: "2",
    rx: "0.5"
  }), /*#__PURE__*/_jsx("rect", {
    x: "4",
    y: "7",
    width: "4",
    height: "10",
    rx: "0.5"
  }), /*#__PURE__*/_jsx("rect", {
    x: "10",
    y: "3",
    width: "4",
    height: "14",
    rx: "0.5"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "11",
    width: "4",
    height: "6",
    rx: "0.5"
  })]
}), 'GraphIcon');